import { orgManagementClient } from '../../api/clients';
import sendEmailVerification from './send-email-verification/send-email-verification';

const emailVerificationService = {
  sendEmailVerification: sendEmailVerification(orgManagementClient),
};

export default emailVerificationService;
